import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {Link} from 'react-router-dom'
import Curriculumleft from '../Curriculum/Curriculumleft'


const AcademicCalenderEle = () => {
    const calendarsData = [
        {
            cname: "Chemistry",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/Msc/M.Sc-CY-2020-21.pdf',    
            glow: false,
            SubHeading:false
        },
        {
            cname: "Mathematics",
            url: '#',    
            glow: false,
            SubHeading: false
        },
        {
            cname: "2025 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2023/MA/MSc_Mathematics.pdf',  
            SubHeading: true,  
            glow: false
        },
        {
            cname: "Mathematics & Statistics",
            url: '#',    
            glow: false,
            SubHeading: false
        },
        {
            cname: "2023 - Batch Onwards",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2023/MA/MSc-MA-2023-24%20onwards_03-01-2024.pdf',  
            SubHeading: true,  
            glow: false
        },
        {
            cname: "2019 - Batch",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/Msc/M.Sc-MA-2019-20.pdf',
            SubHeading: true,
            glow: false  
        },
        {
            cname: "Physics",
            url: 'https://files.iittp.ac.in/pdfs/curriculum/2022/Msc/M.Sc-PH-2020-21.pdf',
            SubHeading: false,
            glow: false   
        }
    ];


    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Curriculumleft activeIndex={3} />
                    </Col>

                    <Col md={8} className='c-right mt-2 ps-5'>
                        <h3 className='text-center mb-5'>M.Sc. Curriculum</h3>
                        <h5>Curriculum for M.Sc. Program are listed as below:</h5>
                                <ul className='ms-4 mt-4 fs-5'>
                                    {calendarsData.map((value, index) => {
                                        return (
                                            <li className='c-lineheight3' key={index}>
                                                <span className={`${value.SubHeading ? 'ms-5' : ''}`}></span>
                                                <i className="fas fa-file-pdf me-3 text-danger"></i>
                                                
                                                <Link to={value.url} target="_blank">

                                                    <span className={`${value.glow ? 'test' : ''}`}>
                                                        {value.cname}
                                                    </span>
                                                    
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                    </Col>
                </Row>
            </Container>
        </section>            
     
    );
};


export default AcademicCalenderEle;
